var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { ProductInstanceFactory } from "./ProductInstanceFactory";
let ProductInstanceParser = class ProductInstanceParser {
    constructor(productInstanceFactory) {
        this.productInstanceFactory = productInstanceFactory;
        makeImmutable(this);
    }
    parseUrl(url) {
        const productTypeIds = url.split("/");
        return this.productInstanceFactory.fromProductTypeIds(productTypeIds);
    }
    parseCartProductKey(cartProductKey) {
        const parts = this.parseInstanceParts(cartProductKey.parts);
        if (parts === null) {
            return null;
        }
        return this.productInstanceFactory.fromStorageData({
            commonConfig: {
                customParameterInstances: this.parseCustomParameterInstances(cartProductKey.customParameters),
                modifierInstances: this.parseModifierInstances(cartProductKey.modifiers),
            },
            parts,
        });
    }
    parseInstanceParts(parts) {
        switch (parts.length) {
            case 1:
                return this.parseSinglePart(parts[0]);
            case 2:
                return this.parseHalves(parts[0], parts[1]);
            default:
                throw new Error(`Unsupported number of product instance parts: ${parts.length}`);
        }
    }
    parseSinglePart(inputPart) {
        const part = this.parsePart(inputPart);
        if (part === null) {
            return null;
        }
        return { type: "SinglePart", part };
    }
    parseHalves(inputFirst, inputSecond) {
        const first = this.parsePart(inputFirst);
        if (first === null) {
            return null;
        }
        const second = this.parsePart(inputSecond);
        if (second === null) {
            return null;
        }
        return { type: "Halves", first, second };
    }
    parsePart(input) {
        return {
            productTypeId: input.productId,
            productConfig: {
                customParameterInstances: this.parseCustomParameterInstances(input.customParameters),
                modifierInstances: this.parseModifierInstances(input.modifiers),
            },
        };
    }
    parseModifierInstances(modifiers) {
        const entries = Object.entries(modifiers).map(([modifierTypeId, modifierValues]) => {
            const items = modifierValues.reduce((acc, key) => {
                if (acc[key] === undefined) {
                    acc[key] = { quantity: 1 };
                }
                else {
                    acc[key].quantity += 1;
                }
                return acc;
            }, {});
            return [modifierTypeId, { items }];
        });
        return Object.fromEntries(entries);
    }
    parseCustomParameterInstances(customParameters) {
        const entries = Object.entries(customParameters).map(([customParameterTypeId, customParameterChoiceId]) => [
            customParameterTypeId,
            { selectedChoice: customParameterChoiceId },
        ]);
        return Object.fromEntries(entries);
    }
};
ProductInstanceParser = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ProductInstanceFactory !== "undefined" && ProductInstanceFactory) === "function" ? _a : Object])
], ProductInstanceParser);
export { ProductInstanceParser };
